// i18n area 'apps' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.hy-AM.meta.json.
import type { enUS } from './apps'

export const hyAM: typeof enUS = {

  // Apps ալիք 1 (Annex R). կառավարվող podman կոնտեյներներ — վորկերի
  // հսկողությամբ մեկ հայտարարված հանգույցի վրա; պատկեր = branch@digest lockfile
  // (Annex Q)՝ pinned/tracking քաղաքականությամբ; untagged L3 կցում ստատիկ IP-ով:
  apps: {
    title: 'Հավելվածներ',
    create: 'Ստեղծել հավելված',
    createTitle: 'Ստեղծել հավելված',
    editTitle: 'Խմբագրել հավելվածը',
    name: 'Անուն',
    nameHint: 'DNS-1123, եզակի սկոուպի ներսում — ստեղծումից հետո անփոփոխ։',
    node: 'Հանգույց',
    nodeHint: 'Մատուցող անդամ հանգույցը — բացահայտ տեղաբաշխում (պլանավորիչը կգա ավելի ուշ)։',
    image: 'Պատկեր',
    editImageHint: 'Նոր հղումը կրկին լուծվում է հաշվառման միջոցով — ամրացման/ետադարձի ժեստը։',
    imagePolicy: 'Քաղաքականություն',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest-ը շարժվում է միայն հրամանով։',
    policyTrackingHint: 'Ավտոմատ գլորվում է, երբ թարմացումը շարժում է ճյուղը։',
    archMovePolicy: 'Cross-arch տեղափոխում',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Ինչ է լինում, եթե app-ը տեղափոխվում է այլ ճարտարապետության node-ի վրա. refuse-ը մերժում է տեղափոխումը, reresolve-ը նորից լուծում է lockfile-ը branch-ից նոր arch-ի վրա — բովանդակությունը փոխվում է, և պատասխանը նշում է digest-ի փոփոխությունը.',
    network: 'Ցանց',
    networkHint: 'Untagged L3 կցում. ֆաբրիկայի տրամաբանական ցանց (խորհուրդ է տրվում — դարպաս/DNS նրա միակ աղբյուրից), օվերլեյ, կամ հոսթի մերկ կամուրջ (խորհուրդ չի տրվում)։',
    overlayPrefix: 'օվերլեյ՝',
    fabricPrefix: 'ֆաբրիկա՝',
    bridgePrefix: 'հոսթի կամուրջ՝',
    ipAssignment: 'IP նշանակում',
    ipStatic: 'Ստատիկ',
    ipAuto: 'Ավտոմատ (IPAM)',
    ipAssignmentHint_static: 'Հասցեն տալիս եք դուք, հիմա։',
    ipAssignmentHint_auto: 'IPAM-ն ընտրում է ազատ հասցե ցանցի TVirt-ին վերապահված միջակայքերից։',
    bridgeDiscouraged: 'Հոսթի մերկ կամուրջ — ԽՈՐՀՈՒՐԴ ՉԻ ՏՐՎՈՒՄ. TVirt-ը ոչինչ չգիտի նրա հասցեավորման մասին, ուստի դարպասը և DNS-ը պետք է տրվեն ձեռքով։ Խորհուրդ տրվող ուղին ֆաբրիկայի տրամաբանական ցանցն է։',
    ip: 'IP',
    ipHint: 'Ստատիկ IPv4 կցման ենթացանցի ներսում։',
    ipCidrHint: 'CIDR ձևով մերկ կամրջի վրա (օր.՝ 192.168.1.10/24) — պրեֆիքսը ածանցելու տեղ չկա։',
    gateway: 'Դարպաս',
    gatewayManualHint: 'Ձեռքով — մերկ կամուրջը ոչինչ չի ածանցում։',
    dnsServers: 'DNS սերվերներ',
    dnsManualHint: 'Ձեռքով, ստորակետով բաժանված — առնվազն մեկը։',
    rootKind: 'Root',
    rootEphemeral: 'անցողիկ',
    rootPersistent: 'մշտական',
    rootEphemeralHint: 'Ամեն վերաստեղծման ժամանակ վերաստեղծվում է պատկերից. ապրում է կլաստերի անցողիկ պահոցի վրա։',
    rootEphemeralHintNamed: 'Ամեն վերաստեղծման ժամանակ վերաստեղծվում է պատկերից. ապրում է կլաստերի անցողիկ պահոցի վրա ({name})։',
    rootPersistentHint: 'Վերապրում է վերագործարկումները. ապրում է ձեր ընտրած պահոցի վրա։',
    rootStorage: 'Root-ի պահոց',
    editRootStorageHint: 'Root-ը վերարտադրվում է նոր պուլի վրա — գոյություն ունեցող տվյալներն ԻՐԵՆՔ ԻՐԵՆՑ չեն տեղափոխվում։',
    volumes: 'Հատորներ',
    volumeAdd: 'Ավելացնել հատոր',
    volumeName: 'Անուն',
    volumeMountPath: 'Միակցման ուղի',
    volumeKind: 'Տեսակ',
    volumeStorage: 'Պահոց',
    devices: 'Սարքեր',
    deviceClassHint: 'Պահանջվում է ԴԱՍ (gpu-device կամ usb-device պիտակ), երբեք կոնկրետ սարք․ հայտարարված հանգույցը պետք է ունենա Հավելվածների համար նշված մեկը։ Մի քանի Հավելված կարող են օգտագործել նույն սարքը — կոնտեյները կիսում է այն, չի խլում հոսթից։',
    deviceSlot: 'Բնիկ',
    deviceTag: 'Պիտակ',
    deviceValue: 'Դաս',
    deviceUnresolved: 'հիմա ոչինչ չի լուծվում',
    noDeviceTags: 'Դեռ չկա gpu-device կամ usb-device տեսակի պիտակ․ ստեղծիր մեկը և վերագրիր Հավելվածների համար նշված սարքերին։',
    env: 'Միջավայր',
    envHint: 'Մեկ ԲԱՆԱԼԻ=արժեք ամեն տողում։',
    secretEnvTitle: 'Գաղտնի փոփոխականներ',
    secretEnvNotice: 'Գաղտնի արժեքն այլևս երբեք չի վերադառնում API-ից. ոչ ոք այն կրկին չի կարդում, նույնիսկ նա, ով գրել է այն։ Checkpoint-ում այն ճամփորդում է Masterpass-ով կնքված, ուստի առանց Masterpass-ի վերականգնումը կխնդրի այն նորից գրել։',
    secretEnvPromote: 'Գաղտնի դարձրեք վերևում գրված փոփոխականներից մեկը՝',
    secretEnvAdd: 'Ավելացնել գաղտնի փոփոխական',
    secretEnvName: 'Անուն',
    secretEnvValue: 'Արժեք',
    secretEnvKept: 'պահպանված — թողեք դատարկ, որպեսզի չփոխվի',
    secretEnvWithdrawWarning: 'Արդեն գաղտնի փոփոխականը գաղտնի համարելը դադարեցնելու համար գրեք դրան նոր արժեք. միայն նշիչը հանելը միջոց կլիներ ԿԱՐԴԱԼՈՒ այն, ինչ store-ից դուրս չի գալիս։ Իսկ այն հեռացնելը ջնջում է այն։',
    secretEnvChip: 'գաղտնի',
    startNow: 'Գործարկել անմիջապես (հակառակ դեպքում հավելվածը ստեղծվում է կանգնեցված)',
    deletePersistentIntro: 'Այս հավելվածն ունի մշտական տվյալներ — ընտրեք՝ ինչ անել դրանց հետ.',
    deleteKeepData: 'Պահել տվյալները (թղթապանակները մնում են իրենց պահոցների վրա՝ որբացած)',
    deletePurgeData: 'Ջնջել նաև տվյալները',
    phase: 'Փուլ',
    phase_running: 'Աշխատում է',
    phase_stopped: 'Կանգնեցված',
    phase_error: 'Սխալ',
    phase_unknown: 'Անհայտ',
    desiredState: 'Ցանկալի',
    wantedRunning: 'աշխատող',
    wantedStopped: 'կանգնեցված',
    start: 'Գործարկել',
    stop: 'Կանգնեցնել',
    restart: 'Վերագործարկել',
    refreshImage: 'Թարմացնել պատկերը (ընդունել նոր @current-ը)',
    logs: 'Մատյան',
    logsTitle: 'Մատյան',
    logsEmpty: 'Գրավված ելք չկա։',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App-ը չի աշխատում — shell-ին անհրաժեշտ է կենդանի կոնտեյներ։ Նրա log-երը կարելի է կարդալ ցանկացած վիճակում։',
    shellConnect: 'Միանալ',
    shellDisconnect: 'Անջատել',
    shellExited: 'Սեսիան ավարտվեց {code} ելքի կոդով։',
    shellEndedWithoutStatus: 'Սեսիան ավարտվեց առանց ելքի կարգավիճակի՝ {reason}',
    shellRevoked: 'Սեսիայի ticket-ն այլևս վավեր չէ — այն սպառվել է, կամ այն բացած մուտքը չեղարկվել է։',
    shellHint: 'Սեղմեք սև դաշտին և գրեք․ ստեղները հասնում են կոնտեյներին։ Ctrl+C-ն և սլաքները գործում են․ exit-ը փակում է shell-ը։',
    shellStatus: {
      connecting: 'Միանում է…',
      connected: 'Միացված',
      ended: 'Ավարտված'
    },
    deleteRunningError: '{name}-ի ցանկալի վիճակն աշխատելն է — նախ կանգնեցրեք այն։',

    // Ստանդարտ երկխոսություն (ռաունդ #156). մանրամասների ներդիրները և պակասող
    // contract դաշտերը — հավելվածի ամեն դաշտ տեսանելի, կողպեքները՝ իրենց պատճառով:
    tabs: {
      general: 'Ընդհանուր',
      image: 'Պատկեր',
      network: 'Ցանց',
      storage: 'Պահոց',
      devices: 'Սարքեր',
      observed: 'Դիտարկված'
    },
    attachment: 'Կցում',
    runningDigest: 'Աշխատող digest-ը',
    lastError: 'Վերջին սխալը',
    reportObservedAt: 'Վորկերի վերջին հաշվետվությունը',
    desiredStateLock: 'Կառավարվում է Գործարկել/Կանգնեցնել գործողություններով — երբեք ուղիղ խմբագրում։',
    ipEditDisabledHint: 'Խմբագրելի է միայն ստատիկ նշանակման դեպքում։',
    derivedFromNetworkHint: 'Ածանցված ցանցի միակ աղբյուրից — ձեռքով միայն մերկ կամրջի վրա՝ ստատիկ IP-ով։',
    ephemeralUnset: 'կարգավորված չէ',
    ephemeralMissing: 'Հավելվածների անցողիկ պահոցը կարգավորված չէ — անցողիկ մասերով (root կամ հատոր) հավելված ստեղծելը մերժվում է, մինչև այն նշանակեք։',
    ephemeralCurrent: 'Հավելվածների անցողիկ պահոց՝ {name}',
    ephemeralMissingCreate: 'Այս հավելվածն ունի անցողիկ մասեր, բայց հավելվածների անցողիկ պահոցը նշանակված չէ — ստեղծումը կմերժվի։ Նախ նշանակեք այն Հավելվածներ էջի բանների միջոցով։',
    setEphemeral: 'Նշանակել անցողիկ պահոց',
    changeEphemeral: 'Փոխել անցողիկ պահոցը',
    setEphemeralTitle: 'Նշանակել հավելվածների անցողիկ պահոցը',
    changeEphemeralTitle: 'Փոխել հավելվածների անցողիկ պահոցը',
    ephemeralStorageHint: 'Կլաստերի մակարդակի ԼՌԵԼՅԱՅՆԸ. dir-անման պուլը, որտեղ ապրում են ամեն հավելվածի անցողիկ root-երն ու անցողիկ հատորները, եթե հավելվածը չի հայտարարել սեփական վերասահմանում։ Փոփոխությունը տաք չէ և ոչինչ չի վերագործարկում. ուժի մեջ է մտնում ամեն հավելվածի հաջորդ գործարկումից — անցողիկ տվյալները չեն տեղափոխվում։',
    ephemeralPool: 'Պահոցի պուլ',
    ephemeralOverride: 'Անցողիկ պահոց (վերասահմանում ըստ հավելվածի)',
    ephemeralOverrideInherit: 'Ժառանգել կլաստերի լռելյայնը',
    ephemeralOverrideInheritNamed: 'Ժառանգել կլաստերի լռելյայնը ({name})',
    ephemeralOverrideHint: 'Ըստ հավելվածի պուլ անցողիկ root-ի և հատորների համար — թողեք դատարկ՝ կլաստերի լռելյայնը ժառանգելու համար։ Փոխելը տաք չէ և ոչինչ չի վերագործարկում. ուժի մեջ է մտնում հաջորդ գործարկումից (անցողիկ տվյալները նոր պուլի վրա վերածնվում են դատարկ) և պահանջում է app.ephemeralStorage.set թույլտվությունը։',
    ephemeralOverrideTag: 'վերասահմանում',

    imageAnyBranch: 'Բոլոր ճյուղերը',
    imageBranchHint: 'Նեղացնում է պատկերները մինչև այս ճյուղի անվանածները. առանց ճյուղի երևում են պահոցի բոլոր պատկերները։',
    imageDigestHint: 'Բովանդակությունը. ընտրվում է digest-երի աղյուսակից, որը կրում է նրա ծագումը և ճարտարապետությունը։ Նույն ճյուղն առաջարկում է մեկը յուրաքանչյուր ճարտարապետության համար, և դրանք փոխարինելի չեն։',
    imageLockfile: 'Լուծված հղում',
    imageNoImages: 'Այս պահոցի համար քեշում պատկեր չկա — ներբեռնիր մեկը OCI պատկերներից։',
    imageHeadNotCached: 'cache-ում չէ — ներբեռնվում է մեկնարկին',
    imageNoRegistries: 'Ոչ մի պահոց գրանցված չէ. գրանցիր մեկը՝ պատկեր ընտրելու համար։',
    imageChosenHint: 'Պատկերն ընտրվում է խմբագրման պատուհանի կասկադից. հղումը երբեք ձեռքով չի գրվում։',
    registerRepositoryHint: 'Գրանցումը ոչինչ չի ներբեռնում. այն դարձնում է պահոցը դիտարկելի, որպեսզի պատկերն ընտրվի առանց այս պատուհանից դուրս գալու։',
    registerRepositoryBranchHint: 'Ըստ ցանկության՝ դիտարկվող առաջին ճյուղը (օր.՝ latest)։',
    registerRepositoryElsewhere: 'Փնտրվող պահոցը գրանցված չէ. գրանցումը կատարվում է OCI պատկերներ բաժնում՝ նրա կողմից, ով ունի թույլտվությունը։'
  },

  // CT ձևանմուշներ (ռաունդ K2 #63). ՆՅՈՒԹԱԿԱՆԱՑՎԱԾ CT օբյեկտները — կատալոգից
  // ներմուծումը միակ մուտքն է; ֆայլերը վերբեռնվում են կատալոգների մեջ:
  cts: {
    createAction: 'Ստեղծել CT',
    createTitle: 'Ստեղծել կոնտեյներ ձևանմուշից',
    createError: 'Կոնտեյները չստեղծվեց',
    template: 'CT ձևանմուշ',
    noTemplates: 'CT ձևանմուշներ չկան — ներմուծեք մեկը CT ձևանմուշներ բաժնից',
    resources: 'Ռեսուրսներ',
    node: 'Հանգույց',
    phase: {
      defined: 'Երբեք չմիացված',
      materializing: 'Նյութականացվում է',
      ready: 'Պատրաստ',
      starting: 'Գործարկվում է',
      running: 'Աշխատում է',
      stopping: 'Կանգնեցվում է',
      stopped: 'Կանգնեցված',
      deleting: 'Ջնջվում է',
      error: 'Սխալի մեջ'
    },
    actions: {
      start: 'Գործարկել',
      stop: 'Կանգնեցնել',
      restart: 'Վերագործարկել',
      markTemplate: 'Դարձնել CT ձևանմուշ',
      error: 'Գործողությունը մերժվել է'
    },
    markTemplate: {
      confirmTitle: "Դարձնե՞լ '{name}'-ը CT ձևանմուշ",
      confirmBody: 'Կոնտեյները լքում է այս ցուցակը և անցնում CT ձևանմուշների մեջ՝ անմիջապես պատրաստ նոր CT-ներ ծնելու։ Նրա մետատվյալները մնում են խմբագրելի, և ցանկացած պահի կարող եք այն նորից CT դարձնել։',
      confirm: 'Դարձնել ձևանմուշ',
      moved: "'{name}'-ն այժմ CT ձևանմուշ է — կգտնեք այն CT ձևանմուշներում։"
    },
    stopCause: {
      api: 'Կանգնեցված TVirt-ի միջոցով',
      'ct-exit': 'Կոնտեյները դուրս եկավ ինքնուրույն',
      'host-reboot': 'Մեռավ հանգույցի վերագործարկման հետ',
      'start-failed': 'Գործարկումը ձախողվեց — առաջադրանքի սխալն ասում է՝ ինչ է պակասում և ինչպես շտկել'
    },

    console: 'Կոնսոլ',
    consoleUnavailable: 'Կոնտեյները չի աշխատում — կոնսոլին պետք է կենդանի կոնտեյներ։ Նրա մատյանը, ընդհակառակը, կարդացվում է ցանկացած վիճակում։',
    consoleNoTemplate: 'Ձևանմուշը երբեք չի աշխատում, ուստի կոնսոլ չունի. ստեղծեք դրանից CT և բացեք նրանը։',
    consoleConnect: 'Միանալ',
    consoleDisconnect: 'Անջատվել',
    consoleReconnect: 'Վերամիանալ',
    consoleTakenBy: 'Այս կոնսոլը վերցրել է մեկ այլ օպերատոր ({user})։ Մեկ կոնսոլ՝ մեկ կոնտեյների համար. վերամիանալը այն վերադարձնում է ձեզ։',
    consoleHint: 'Սեղմեք սև դաշտի վրա և գրեք. ստեղները հասնում են կոնտեյներին։ Ctrl+C-ն և սլաքներն աշխատում են։',
    consoleEndpointDown: 'Կոնսոլի մուտքի կետը չի բացվում container-ը սպասարկող հանգույցում՝ {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container-ը չի աշխատում — shell-ին կենդանի container է պետք։ Նրա log-երը կարդացվում են ցանկացած վիճակում։',
    shellNoTemplate: 'Template-ը երբեք չի աշխատում, ուստի shell չունի․ ստեղծեք դրանից CT և բացեք դրա shell-ը։',
    shellConnect: 'Միանալ',
    shellDisconnect: 'Անջատել',
    shellExited: 'Սեսիան ավարտվեց {code} ելքի կոդով։',
    shellEndedWithoutStatus: 'Սեսիան ավարտվեց առանց ելքի կարգավիճակի՝ {reason}',
    shellRevoked: 'Սեսիայի ticket-ն այլևս վավեր չէ — այն սպառվել է, կամ այն բացած մուտքը չեղարկվել է։',
    shellHint: 'Սեղմեք սև դաշտին և գրեք․ ստեղները հասնում են կոնտեյներին։ Ctrl+C-ն և սլաքները գործում են․ exit-ը փակում է shell-ը։',
    shellStatus: {
      connecting: 'Միանում է…',
      connected: 'Միացված',
      ended: 'Ավարտված'
    },
    rootPassword: 'root-ի գաղտնաբառ',
    rootPasswordHint: 'Գրվում է մեկ անգամ պատճենված rootfs-ում (որպես hash, այլևս չի ցուցադրվում)։ Դիստրիբուտիվների image-ները root-ի գաղտնաբառ չունեն․ առանց դրա shell-ը միակ մուտքն է։',
    sshKeys: 'root-ի հանրային SSH բանալիներ',
    sshKeysHint: 'Մեկ հանրային OpenSSH բանալի յուրաքանչյուր տողում՝ root/.ssh/authorized_keys-ում։',
    consoleStatus: {
      connecting: 'Միացում…',
      connected: 'Միացված',
      reconnecting: 'Վերամիացում…'
    },
    logs: 'Մատյան',
    logsTitle: 'Մատյան',
    logsEmpty: 'Գրավված ելք չկա։',
    logsSource: 'Որ մատյանը',
    logsSourceConsole: 'Կոնտեյների init-ի կոնսոլը — ինչու ներսի ծառայությունը չմեկնարկեց',
    logsSourceSupervisor: 'liblxc վերահսկիչը — ինչու կոնտեյները երբեք չհասավ աշխատելուն',
    logsNeverStarted: 'Այն երբեք չի գործարկվել, ուստի դեռ ոչինչ գրանցված չէ — գործարկեք այն, և մատյանը կլինի նույնիսկ եթե գործարկումը ձախողվի։',
    logsNoTemplate: 'Ձևանմուշը երբեք չի աշխատում, ուստի երբեք ոչինչ չի գրանցել։',
    logsError: 'Մատյանը չհաջողվեց գրավել',

    // Ստանդարտ երկխոսություն (ռաունդ #156). CT և CT ձևանմուշ ցուցակների
    // ընդհանուր մանրամասների ներդիրները, գումարած կողպեքները՝ իրենց պատճառով:
    tabs: {
      general: 'Ընդհանուր',
      hardware: 'Սարքաշար',
      network: 'Ցանց',
      provenance: 'Ծագում'
    },
    templateFlag: 'CT ձևանմուշ',
    templateLock: 'Փոխվում է միայն Դարձնել ձևանմուշ / Վերադարձնել CT-ի գործողություններով — երբեք ուղիղ խմբագրում։',
    sourceLock: 'Ծագումը՝ գրանցված ծննդյան պահին — երբեք չի վերագրվում. մեռած աղբյուրը թողնում է մերկ հղումը։',
    storageLock: 'Ամրագրված ստեղծման պահին — rootfs-ի տեղափոխումը ապագա ռաունդի գործ է։',
    startedAt: 'Գործարկվել է',
    lastStop: 'Վերջին կանգը',
    editNicsTitle: 'Խմբագրել ցանցերը',
    nicDisconnected: 'անջատված'
  },
  ctTemplates: {
    title: 'CT ձևանմուշներ',
    importAction: 'Ներմուծել կատալոգից',
    importTitle: 'Ներմուծել CT ձևանմուշ կատալոգից',
    importSubmit: 'Ներմուծել',
    importError: 'Ներմուծումը մերժվեց',
    importHint: 'Նյութականացումը պատճենում է rootfs-ը ընտրված պահոցի վրա — կատալոգի ֆայլը մնում է անձեռնմխելի։ Նոր ֆայլեր ավելացնելու համար նախ վերբեռնեք դրանք կատալոգի մեջ։',
    sourceFile: 'CT ձևանմուշի ֆայլ',
    sourceFileHint: 'Ընտրված կատալոգի ct-rootfs ֆայլերը, միայն պատրաստները',
    noFiles: 'Այս կատալոգում պատրաստ ct-rootfs ֆայլ չկա — նախ վերբեռնեք մեկը կատալոգի էջից',
    source: 'Աղբյուր ֆայլ',
    rootfsStorage: 'Rootfs-ի պահոց',
    rootfsStorageHint: "Որտեղ ապրում է դուրս բերված rootfs ծառը — ֆայլային համակարգի վրա հիմնված պահոց՝ բավարար ազատ տարածքով դուրս բերված չափի համար՝ գումարած մոտ 1 GiB պահուստ (հակառակ դեպքում ներմուծումը ձախողվում է)։",
    resources: 'Ռեսուրսներ',
    cores: 'vCPU',
    memoryMiB: 'Հիշողություն (MiB)',
    cpuLimit: 'CPU սահման',
    cpuLimitHint: 'Հոսթի միջուկների համարժեքներ (օր.՝ 1.5). դատարկ = առանց առաստաղի',
    cpuUncapped: 'առանց առաստաղի',
    cpuWeight: 'CPU կշիռ',
    hostname: 'Հոսթի անուն',
    hostnameHint: 'Դատարկ = CT-ի սեփական անունը',
    nameservers: 'DNS nameserver-ներ',
    dnsHint: 'Ստորակետով բաժանված. դատարկ = ժառանգում է հոսթինը',
    searchDomains: 'DNS որոնման դոմեններ',
    dnsInherited: 'Ժառանգված հոսթից',
    networks: 'Ցանցեր',
    nicSlot: 'NIC սլոթ',
    phase: {
      materializing: 'Նյութականացվում է',
      ready: 'Պատրաստ',
      deleting: 'Ջնջվում է',
      error: 'Սխալ'
    },
    exportAction: 'Արտահանել կատալոգ',
    exportTitle: 'Արտահանել կատալոգ',
    exportSubmit: 'Արտահանել',
    exportError: 'Արտահանումը մերժվեց',
    exportHint: 'Փաթեթավորում է նյութականացված rootfs-ը ՆՈՐ ct-rootfs ֆայլի մեջ ընտրված կատալոգում — ձևանմուշը մնում է անձեռնմխելի։',
    exportName: 'Ֆայլի անուն',
    exportNameHint: 'Դատարկ = <template>-export-<n>',
    markCt: {
      action: 'Վերադարձնել CT-ի',
      confirmTitle: "Վերադարձնե՞լ '{name}'-ը CT-ի",
      confirmBody: 'Ձևանմուշը լքում է այս ցուցակը և վերադառնում CT-ների ցուցակ՝ նորից գործարկելի։ Մինչև այն նորից ձևանմուշ դարձնեք, նրանից նոր CT-ներ ստեղծել հնարավոր չէ։',
      confirm: 'Վերադարձնել',
      moved: "'{name}'-ը նորից սովորական CT է — կգտնեք այն CT ցուցակում։"
    }
  },

  // OCI ալիք 1 (Annex Q — թեգը-որպես-ճյուղ մոդելը). OCI թեգը ճյուղ է (շարժուն
  // ցուցիչ), digest-ը՝ կոմիտը; refresh = «git fetch»,
  // pull = լուծիր ՀԻՄԱ, ներբեռնիր ՀԵՆՑ ԱՅԴ digest-ը:
  oci: {
    registriesTitle: 'OCI ռեգիստրներ',
    imagesTitle: 'OCI պատկերներ',
    provider: 'Պրովայդեր',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Ընդհանուր',
    providerImmutableHint: 'Պրովայդերը ստեղծումից հետո անփոփոխ է — այլ պրովայդերը նոր ռեգիստր է։',
    url: 'URL',
    urlHintPreset: 'Նախալրացված է պրովայդերի կողմից — վերասահմանեք միայն հայելիների համար։',
    urlHintRequired: 'Պարտադիր է ընդհանուր ռեգիստրների համար. https:// հիմքային URL-ը։',
    urlHintEcr: 'Պարտադիր է. ECR վերջնակետերն ըստ հաշվի/ըստ տարածաշրջանի են — նախադրված արժեք չկա։',
    credential: 'Հավատարմագրեր',
    credentialNone: 'Անանուն մուտք',
    credentialHint: 'Օգտանուն-գաղտնաբառ գրառում բանալիների պահոցում. վորկերները լուծում են այն օգտագործման պահին — երբեք auth ֆայլեր ըստ հանգույցի։',
    nameHint: 'Հոսթանման անուն (docker.io, registry.intra). եզակի ըստ սկոուպի, անփոփոխ',
    addRegistry: 'Ավելացնել ռեգիստր',
    addRegistryTitle: 'Ավելացնել OCI ռեգիստր',
    verify: 'Ստուգել',
    verifyState: 'Ստուգում',
    verified: 'Ստուգված',
    verifyFailed: 'Ձախողված',
    neverVerified: 'Երբեք չի ստուգվել',
    registryInUseError: "'{name}'-ը դեռ գրանցված շտեմարաններ ունի — նախ ջնջեք դրանք։",
    repositories: 'Շտեմարաններ',
    repositoriesHint: 'Գրանցումը դիտարկում է ճյուղերը (OCI թեգերը) — ոչինչ չի ներբեռնվում։ Թարմացումը լուծում է ամեն դիտարկվող ճյուղ և պահում reflog-ը։',
    noRepositories: 'Այս ռեգիստրի վրա գրանցված շտեմարաններ չկան։',
    registerRepository: 'Գրանցել շտեմարան',
    repoPath: 'Ուղի',
    repoPathHint: "Շտեմարանի ուղին ռեգիստրի վրա, օր.՝ 'example' կամ 'library/nginx'",
    branches: 'Ճյուղեր',
    branchesHint: 'Դիտարկվող ճյուղեր (OCI թեգեր)՝ ստորակետով բաժանված — օր.՝ 1.1.0, 1.1.1',
    branch: 'Ճյուղ',
    branchPullHint: 'Լուծված ՀԻՄԱ. pull-ը ներբեռնում է այն digest-ը, որին ճյուղը ցույց է տալիս այսօր։',
    refresh: 'Թարմացնել',
    deleteRepository: 'Ջնջել շտեմարանը',
    reflogCount: '{n} նախորդ',
    noResolutions: 'Երբեք չի թարմացվել — դիտարկված լուծումներ չկան։',
    refreshFailed: 'Վերջին թարմացումը ձախողվեց ({when})',
    loadError: 'Չհաջողվեց բեռնել շտեմարանները։',
    reference: 'Հղում',
    digest: 'Digest',
    digestHint: 'sha256:… — ճշգրիտ պատկերը, առանց ճյուղի (detached)',
    size: 'Չափ',
    nodes: 'Հանգույցներ',
    detached: 'detached',
    detachedHint: 'Ներբեռնված digest-ով, առանց ճյուղի — դրեյֆի ստուգումը չի կիրառվում։',
    pulledAt: 'Ներբեռնված',
    pull: 'Pull',
    pullTitle: 'Պատկերի pull',
    pullHint: 'Նախնական տաքացում, երբեք ոչ նախապայման. ճյուղով pull-ը լուծում է ՀԻՄԱ և ներբեռնում ՀԵՆՑ ԱՅԴ digest-ը. digest-ով pull-ը detached է։',
    pullError: 'Pull-ը մերժվեց',
    pullMode: 'Pull ըստ',
    pullModeBranch: 'Ճյուղի (լուծել հիմա)',
    pullModeDigest: 'Digest-ի (detached)',
    pullModeBranchHint: 'Ազնիվ լռելյայնը. ինչպես apt install-ը, ավելի ուշ կրկին գործարկելը կարող է տալ այլ պատկեր։',
    pullModeDigestHint: 'Ճշգրիտ digest — վերարտադրելիություն և ետադարձ. հրաժարվում է դրեյֆի ստուգումից։',

    // Երկու կոճակի ներմուծման օրինաչափությունը (#88, վավերացվել է 2026-07-30
    // երեկոյան). «ռեգիստրից»-ը գոյություն ունեցող ուղղորդված pull-ն է,
    // «կատալոգից»-ը նյութականացնում է պատրաստ oci-image արխիվ (air-gapped ուղին):
    importFromRegistry: 'Ներմուծել ռեգիստրից',
    importFromCatalog: 'Ներմուծել կատալոգից',
    importCatalogTitle: 'Ներմուծել OCI պատկեր կատալոգից',
    importCatalogHint: 'Air-gapped ուղին. պատրաստ oci-image արխիվը (tar/tar.gz — docker-archive կամ oci-archive) նյութականացվում է պատկերների պահոցում catalog/<կատալոգ>/<ֆայլ>@<digest> հղումով. հավելվածներն այն սպառում են ինչպես ցանկացած այլ պատկեր։ Արխիվները վերբեռնվում են կատալոգներում — այս բաժինը միայն ներմուծում է։',
    importCatalogFile: 'Արխիվ',
    importCatalogFileHint: 'Ընտրված կատալոգի պատրաստ oci-image ֆայլերը։',
    importCatalogNoFiles: 'Այս կատալոգում պատրաստ oci-image արխիվ չկա — վերբեռնեք մեկը կատալոգի մանրամասներից։',
    importCatalogError: 'Ներմուծումը մերժվեց',
    registry: 'Ռեգիստր',
    repository: 'Շտեմարան',
    cacheMissing: 'Կլաստերի OCI քեշը կարգավորված չէ — pull-երը մերժվում են, մինչև պահոցի պուլ նշանակվի։',
    setCache: 'Նշանակել քեշ',
    setCacheTitle: 'Կարգավորել OCI քեշը',
    setCacheHint: 'Կլաստերի մակարդակի ԼՌԵԼՅԱՅՆ պուլը, որտեղ ապրում են ներբեռնված պատկերների blob-ները — սկոուպը կարող է վերասահմանել այն սեփական պուլով (Սկոուպներ էջ)։ Փոխելը տաք չէ և ոչինչ չի վերագործարկում, և երբեք չի տեղափոխում blob-ները. դրանք ծույլ կերպով նորից են հայտնվում հաջորդ գործարկման/օգտագործման ժամանակ։',
    cachePool: 'Պահոցի պուլ',
    changeCache: 'Փոխել քեշը',
    changeCacheTitle: 'Փոխել OCI քեշի պուլը',
    cacheCurrent: 'Կլաստերի OCI քեշ (լռելյայն)՝ {name}',
    sectionOverview: 'Ընդհանուր պատկեր',
    sectionRepositories: 'Շտեմարաններ',
    sectionExplore: 'Ուսումնասիրել',
    exploreHint: 'Կենդանի հեռավոր որոնում ռեգիստրի վրա — Docker Hub-ը լիարժեք (նկարագրություն, ներբեռնումներ, աստղեր), մյուս պրովայդերները՝ ըստ հնարավորության։ Ընտրեք արդյունք՝ նրա ամբողջական նկարագրությունը կարդալու և հեռավոր թեգերը թերթելու համար. թեգից կարող եք հղումն ավելացնել TVirt շտեմարանի մեջ։',
    exploreSearch: 'Որոնել',
    exploreUnsupported: 'Այս պրովայդերը որոնում չի աջակցում։',
    exploreNoResult: 'Համապատասխանող շտեմարան չկա։',
    exploreNoTags: 'Այս շտեմարանում համապատասխանող թեգ չկա։',
    exploreOfficial: 'Պաշտոնական',
    explorePulls: 'Ներբեռնումներ',
    exploreStars: 'Աստղեր',
    exploreUpdated: 'Թարմացվել է {when}',
    exploreLoadMore: 'Բեռնել ավելին',
    exploreSelectHint: 'Ընտրեք արդյունք. ամբողջական նկարագրությունը և հեռավոր թեգերը բեռնվում են հենց այստեղ։',
    exploreNoDescription: 'Այս պրովայդերից նկարագրություն հասանելի չէ։',
    exploreTagsTitle: 'Հեռավոր թեգեր',
    exploreTagFilter: 'Որոնել թեգեր',
    exploreAddToRepo: 'Ավելացնել շտեմարանի մեջ',
    exploreAdded: '{path}:{tag}-ն այժմ հետևվում է — տես Շտեմարաններ բաժինը։',
    addBranch: 'Ավելացնել ճյուղ',
    purgeRequiredTitle: "Ջնջե՞լ '{name}'-ը և նրա պատկերները",
    purgeRequiredBody: 'Ոչ մի հավելված չի սպառում այս շտեմարանը, բայց ներբեռնված պատկերներ դեռ կան. այն ջնջելը հեռացնում է նաև նրանց գրառումները, և քեշված blob-ներն անցնում են աղբահավաքին։',
    purgeConfirm: 'Ջնջել նաև պատկերները',
    providerSelectHint: 'Ընտրեք ռեգիստրի տեսակը. քարտը պատմում է նախադրվածի և կիրառության մասին։',
    providerDesc: {
      dockerhub: 'Հանրային Docker ռեգիստրը. նախադրված URL, լիարժեք որոնում՝ նկարագրություններով և հաշվարկներով։',
      ghcr: 'GitHub Container Registry. նախադրված URL; հաշիվներն օգտագործում են անձնական մուտքի թոքեն։',
      ecr: 'Amazon Elastic Container Registry. վերջնակետերն ըստ հաշվի/ըստ տարածաշրջանի են — URL-ը պետք է նշվի։',
      quay: 'Red Hat Quay ռեգիստրը. նախադրված URL։',
      generic: 'Սեփական հոսթինգով ռեգիստր (Harbor, registry:2, …). https:// URL-ը պարտադիր է։'
    },

    // Ստանդարտ երկխոսություն (ռաունդ #156). պատկերի/ռեգիստրի մանրամասների
    // դաշտերը, որոնք սյունակները չէին ցուցադրում:
    layerCount: 'Շերտեր',
    verifiedAt: 'Վերջին ստուգումը',
    verifyOk: 'Արդյունք',
    verifyMessage: 'Ստուգման հաղորդագրություն',

    // Մոդել #348/R39. պատկերը ԴԱ digest-ն է — բովանդակությունը —, իսկ registry-ն, պահոցը և ճյուղը ԱՆՈՒՆՆԵՐ են, որոնք հասնում են դրան.
    head: 'Head',
    heads: 'Գլուխներ ըստ ճարտարապետության',
    listDigest: 'Ցանկի digest-ը',
    neverResolved: 'Երբեք չի լուծվել',
    totalSize: 'Ընդհանուր չափ',
    reflogTitle: 'Լուծումների պատմություն',
    usedBy: 'Օգտագործողը',
    usageLockfile: 'lockfile',
    usageRunning: 'աշխատող',
    evictable: 'դուրսմղելի',
    evict: 'Դուրս մղել քեշից',
    evictHeadTitle: 'Դուրս մղե՞լ {digest}-ը',
    evictHeadBody: 'Այն առնվազն մեկ կոլեկտորի ընթացիկ լուծումն է. այն դուրս մղելը լեգիտիմ է — սա միայն քեշ է, հեռավոր ճյուղը դեռ մատուցում է այն — բայց դա երբեք չպետք է պատահի սխալմամբ։ Blob-ը ՄԵԿՆ է. դուրսմղումը դատարկում է այն կիսող բոլոր կոլեկտորները։',
    evictConfirm: 'Միևնույն է դուրս մղել',

    arch: 'Ճարտարապետություն',
    names: 'Անուններ',
    noNames: 'առանց անվան',
    views: 'Դիտումներ',
    lastView: 'վերջին դիտումը',
    evictLastViewTitle: 'Հեռացնե՞լ {digest}-ի վերջին հղումը:',
    evictLastViewBody: 'Սա այս բովանդակության վերջին դիտումն է. այն հեռացնելով՝ պատկերը դադարում է գոյություն ունենալ TVirt-ում, և բայթերը ({size}) ազատվում են։ Սա մոդելի docker image rm-ն է — ոչ թե կողմնակի ազդեցություն, այլ ինքը գործողությունը։',
    branchesTabHint: 'Այս պահոցի դիտարկվող ճյուղերը. յուրաքանչյուրի համար այսօրվա գլուխները՝ մեկը յուրաքանչյուր ճարտարապետության համար, թարմացումների ժամանակագրությունը և թե նրա անվանած պատկերներից քանիսն են քեշում։ Թարմացումը պահոցի «git fetch»-ն է. այն մեկ անգամից լուծում է բոլոր ճյուղերը։',
    noBranches: 'Այս պահոցում ոչ մի ճյուղ չի դիտարկվում։',
    stopObserving: 'Դադարեցնել ճյուղի դիտարկումը',
    pullBranch: 'Ներբեռնել cache-ում branch-ի գլուխը (refresh-ը լուծում է, սա ներբեռնում է)',
    pullDigest: 'Ներբեռնել cache-ում այս digest-ը',
    imageCount: 'Պատկերներ',
    deleteBranchPurgeTitle: 'Թողնե՞լ {name}-ի պատկերները առանց անվան:',
    deleteBranchPurgeBody: 'Ոչ մի հավելված չի անվանում այս ճյուղը, բայց որոշ պատկերների հասնում են միայն նրանով. այն ջնջելով՝ դրանք մնում են քեշում առանց անվան, թվարկված պահոցի պատկերների մեջ և ձեռքով հեռացվող։',
    deleteBranchPurgeConfirm: 'Ջնջել և թողնել պատկերները առանց անվան',
    imagesTabHint: 'Այս պահոցի պատկերները — բովանդակությունները, այսինքն՝ digest-երը — տեսանելի են նաև առանց ճյուղ ընտրելու։ Պատկերը եզակի է կլաստերի համար. նրան հասնող անունները կարող են մեկից ավելի լինել։',
    noImages: 'Այս պահոցի ոչ մի պատկեր քեշում նյութականացված չէ։',
    deleteRepositoryTitle: 'Ջնջե՞լ {name}-ը:',
    deleteRepositoryBody: 'Պահոցը և նրա ճյուղերը անհետանում են իրենց ժամանակագրությամբ։ Պատկերները մնում են քեշում. կորցնում են միայն այս անունը։ Հավելվածի կողմից անվանված պահոցը չի ջնջվում։',
    provenanceCatalog: 'կատալոգ',
    refreshedAt: 'Թարմացվել է',
    neverRefreshed: 'Երբեք չի թարմացվել',
    sectionBranches: 'Ճյուղեր',
    sectionImages: 'Պատկերներ',
    repositoriesGovernedElsewhere: 'Այստեղ պահոցները միայն դիտվում են. գրանցելը, թարմացնելը, ճյուղերը դիտարկելը և պատկերները հեռացնելը կատարվում է OCI պատկերներ բաժնում։',
    gotoImages: 'Անցնել OCI պատկերներ'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pod-եր',
    containers: 'Կոնտեյներներ',
    instances: 'Օրինակներ',
    instancesTooltip: '{running} աշխատող, {error} սխալով',
    placement: 'Տեղաբաշխում',
    spread: 'բաշխում',
    ha: 'HA',
    templateRevision: 'վերանայում',
    deleting: 'Ջնջվում է',
    empty: 'Pod-եր չկան — ստեղծեք հավելված (մեկ կոնտեյներ) կամ pod CLI-ից (create-pod):',
    openInstances: 'Բացել օրինակները',
    rollingRestart: 'Փուլային վերագործարկում',
    scale: 'Մասշտաբավորել',
    scaleTitle: 'Մասշտաբավորել {name}',
    scaleHint: 'Օրինակների քանակը (0–64). վերև՝ զբաղեցվում է ամենացածր ազատ հերթականը, ներքև՝ հեռացվում է ամենաբարձրը, նրա մշտական տվյալները մնում են:',
    scaleError: 'Մասշտաբավորումը ձախողվեց',
    replicas: 'Կրկնօրինակներ',
    deleteRunningError: '{name}-ն աշխատում է — նախ կանգնեցրեք այն:',
    deleteInstancesIntro: 'Բոլոր {count} օրինակները կհեռացվեն:',
    stateRunning: 'Աշխատում է',
    stateStopped: 'Կանգնեցված',
    editor: {
      createTitle: 'Ստեղծել Pod',
      create: 'Ստեղծել Pod',
      editTitle: 'Խմբագրել Pod-ը',
      nameHint: 'DNS-1123, առավելագույնը 58 նիշ — օրինակները կոչվում են <անուն>-<ինդեքս>. անփոփոխ ստեղծումից հետո։',
      restartPolicy: 'Վերագործարկման քաղաքականություն',
      restartPolicyHint_always: 'Հանգույցը վերագործարկում է ցանկացած ավարտված կոնտեյներ՝ էքսպոնենցիալ սպասումով (10 վ → 5 ր)։',
      restartPolicyHint_onFailure: 'Վերագործարկվում է միայն ոչ զրոյական կոդով ավարտված կոնտեյները. ելք 0-ը մնում է հանգիստ։',
      restartPolicyHint_never: 'Ավարտված կոնտեյները մնում է ինչպես կա — օրինակն ավարտվում է succeeded կամ failed։',
      grace: 'Հետաձգում (վ)',
      graceHint: 'Կանգառի SIGTERM → SIGKILL սահմանը։',
      hostname: 'Հոսթի անուն',
      hostnameHint: 'Դատարկ = օրինակի անունը։',
      hostnameDefault: 'օրինակի անունը',
      sharePid: 'Կիսել PID անվանատարածքը կոնտեյներների միջև',
      containersIntro: 'Init կոնտեյներներն աշխատում են մինչև վերջ, հերթով, նախքան կոնտեյներների մեկնարկը. կոնտեյներները կիսում են օրինակի ցանցը (մեկ IP, localhost իրար միջև)։',
      initContainers: 'Init կոնտեյներներ',
      initAdd: 'Ավելացնել init կոնտեյներ',
      initHint: 'Յուրաքանչյուրը պետք է ավարտվի 0-ով. ձախողումը օրինակը դնում է սխալի մեջ, և հանգույցը կրկնում է սպասումով։',
      containerAdd: 'Ավելացնել կոնտեյներ',
      atLeastOne: 'Pod-ին անհրաժեշտ է առնվազն մեկ կոնտեյներ։',
      duplicateNames: 'Կոնտեյներների անունները Pod-ում պետք է եզակի լինեն (ներառյալ init կոնտեյներները)։',
      containerName: 'Կոնտեյների անուն',
      containerInvalid: 'Այս կոնտեյները թերի է. անուն (DNS-1123), պատկեր, մոնտաժներ հայտարարված ծավալների վրա, թվային սահմաններ և զոնդ։',
      command: 'Հրաման',
      commandHint: 'Փոխարինում է պատկերի entrypoint-ը — մեկ արգումենտ տողում, երբեք shell տող։',
      args: 'Արգումենտներ',
      argsHint: 'Մեկը տողում (պատկերի CMD-ն, եթե դատարկ է)։',
      mounts: 'Մոնտաժներ',
      mountAdd: 'Ավելացնել մոնտաժ',
      mountNoVolumes: 'Նախ հայտարարեք ծավալ Պահեստ ներդիրում։',
      readOnly: 'միայն կարդալու',
      resources: 'Սահմաններ',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (օր. 1.5)',
      memory: 'Հիշողություն (MiB)',
      memoryHint: 'podman --memory',
      health: 'Կենսունակության զոնդ',
      healthCmd: 'Զոնդի հրաման',
      healthCmdHint: 'Կատարվում է հանգույցի կողմից կոնտեյների ներսում վերահսկման ամեն տակտին — մեկ արգումենտ տողում. ելք 0 = առողջ։',
      healthTimeout: 'Ժամանակի սահման (վ)',
      healthRetries: 'Փորձեր',
      healthRetriesHint: 'Հաջորդական ձախողումներ, նախքան հանգույցը կվերագործարկի կոնտեյները։',
      ips: 'Ստատիկ հասցեներ',
      ipsHint: 'Մեկը յուրաքանչյուր օրինակի համար, հերթական կարգով — ցուցակից դուրս մասշտաբավորումը մերժվում է։',
      instance: 'օրինակ',
      volumesHint: 'Ծավալները Pod-ինն են. մոնտաժի ուղին՝ յուրաքանչյուր կոնտեյների (Կոնտեյներներ ներդիր)։',
      spread: 'Բաշխում',
      spreadHint_preferred: 'Օրինակները տարբեր հանգույցներում, երբ հնարավոր է։',
      spreadHint_required: 'Օրինակները տարբեր հանգույցներում, այլապես մասշտաբավորումը մերժվում է։',
      spreadHint_none: 'Միայն որոշում կայացնողը։',
      ha: 'Բարձր հասանելիություն (opt-in)',
      haHint: 'Յուրաքանչյուր մշտական մաս ընդհանուր storage-ի վրա. եթե հանգույցը մահանա, HA decider-ը վերստեղծում է օրինակները այլ անդամի վրա (ավտոմատ failover, ինչպես HA VM-ները)։',
      yes: 'այո',
      no: 'ոչ'
    },
    detail: {
      container: 'Կոնտեյներ',
      actions: 'Գործողություններ',
      ready: 'Պատրաստ',
      notReady: 'Պատրաստ չէ',
      restarts: 'Վերագործարկումներ',
      lastRestartAt: 'Վերջին վերագործարկում՝',
      backoffUntil: 'Կրկին փորձ՝',
      stateAbsent: 'բացակայում է',
      stateRunning: 'աշխատում է',
      stateTerminated: 'ավարտված',
      stateWaiting: 'սպասում է',
      init: 'init',
      noInstances: 'Օրինակներ չկան (կրկնօրինակներ 0)։',
      ha: 'HA',
      haHint: 'Ավտոմատ failover. եթե հանգույցը մահանա, HA decider-ը վերստեղծում է օրինակը այլ անդամի վրա (յուրաքանչյուր մշտական մաս ընդհանուր storage-ի վրա)։',
      authority: 'Authority (հանգույց)',
      homeless: 'առանց authority-ի',
      homelessHint: 'Checkpoint-ից վերականգնումը authority-ն դուրս է թողնում (#380). ոչ մի հանգույց չի սպասարկում այն, մինչև Pod-ը չմասշտաբավորեք (թեկուզ նույն քանակի կրկնօրինակների)։',
      restartContainer: 'Վերագործարկել միայն այս կոնտեյները (pod-ը մնում է աշխատող)',
      divergingHint: 'Այս օրինակի ցանկալի վիճակը տարբերվում է Pod-ի լռելյայնից (PD-P19)։',
      revisionLag: 'կիրառված է {applied} վերանայումը {current}-ից',
      updatedInstances: '{updated}/{desired} օրինակ այս վերանայման վրա'
    }
  }
}
